export enum StorageKeys {
  MobileHelpScreenShown = 'mobile-help-screen-shown',
}
